import PropTypes from 'prop-types';
import React from 'react';

const Spinner = ({ size = 'sm', color = 'white', className = '' }) => {
  const sizeClasses = {
    sm: 'w-4 h-4 border-2',
    md: 'w-8 h-8 border-4',
    lg: 'w-12 h-12 border-4',
  };

  const colorClasses = {
    blue: 'border-blue-500 border-t-transparent',
    red: 'border-red-500 border-t-transparent',
    green: 'border-green-500 border-t-transparent',
    yellow: 'border-yellow-500 border-t-transparent',
    gray: 'border-gray-500 border-t-transparent',
    white: 'border-gray-100 border-t-transparent',
  };

  return (
    <div
      className={`animate-spin rounded-full ${sizeClasses[size]} ${colorClasses[color]} ${className}`}
      role="status"
      aria-label="Loading"
    ></div>
  );
};

Spinner.propTypes = {
  size: PropTypes.oneOf(['sm', 'md', 'lg']),
  color: PropTypes.oneOf(['blue', 'red', 'green', 'yellow', 'gray', 'white']),
  className: PropTypes.string,
};

export default Spinner;
